module.exports = __webpack_public_path__ + "img/businessAccount.9ee1b059.svg";